/* eslint-disable no-return-assign */
import React, { PureComponent, Fragment } from 'react';
import { withTranslation } from 'react-i18next';
import { Card, CardBody, Col, Row, Container } from 'reactstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import NotificationSystem from 'rc-notification';
import columns from './components/Columns';
import MatTable from '../../shared/components/material-table';
import GraphQL from '../../GraphQL';
import EducationStageForm from './components/Form';
import Modal from '../../shared/components/Modal';
import {
  changeLoadingTrue,
  changeLoadingFalse,
} from '../../redux/actions/loadingActions';
import { showNotification } from '../../shared/components/ShowNotification';
import {
  educationStageListAllQuery,
  removeEducationStageMutation,
  saveEducationStageMutation,
} from '../../shared/queries/EducationStage';

let notificationInstance = null;

class EducationStage extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    dispatch: PropTypes.func.isRequired,
  };

  constructor() {
    super();
    this.state = {
      data: [],
      formOn: false,
      modal: false,
      selectedDto: {},
    };
    this.deleteItem = this.deleteItem.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
  }

  componentDidMount() {
    NotificationSystem.newInstance({}, (n) => (notificationInstance = n));
    this.loadData();
  }

  componentWillUnmount() {
    notificationInstance.destroy();
  }

  loadData = () => {
    this.showLoading();
    const dataQuery = educationStageListAllQuery();
    const { t } = this.props;
    GraphQL(dataQuery, {})
      .then((res) => {
        this.hideLoading();
        let educationStageList = res.educationStageListAll;
        educationStageList = educationStageList.map((item) => ({
          ...item,
          activeDescription: t(`general.yesno.${item.active}`),
        }));
        this.setState({ data: educationStageList });
      })
      .catch((erro) => {
        this.hideLoading();
        console.error(erro);
      });
  };

  addItemClickHandler = () => {
    this.setState({ formOn: true, selectedDto: { active: true, id: 0 } });
  };

  editItemClickHandler = (evt, rowData) => {
    const clickedItem = {
      ...rowData,
    };
    this.setState({ formOn: true, selectedDto: clickedItem });
  };

  removeItemClickHandler = (evt, rowData) => {
    const clickedItem = {
      ...rowData,
    };
    this.setState({ selectedDto: clickedItem });
    this.toggleModal();
  };

  deleteItem = () => {
    this.toggleModal();
    this.showLoading();
    const { selectedDto } = this.state;
    const removeQuery = removeEducationStageMutation(selectedDto.id);
    GraphQL(removeQuery, {})
      .then(() => {
        this.notification(
          'success',
          'Sucesso',
          'Registro eliminado com sucesso.'
        );
        this.loadData();
        this.hideLoading();
      })
      .catch(() => {
        this.hideLoading();
        this.notification(
          'danger',
          'Erro',
          'Não foi possível eliminar este registro. Em caso de dúvidas, entre em contato com nosso suporte técnico'
        );
      });
  };

  backClickHandler = () => {
    this.setState({ formOn: false });
    this.loadData();
  };

  handleSubmit = (values) => {
    this.showLoading();
    const mutationQuery = saveEducationStageMutation(values);
    GraphQL(mutationQuery, {}).then(
      () => {
        this.hideLoading();
        this.backClickHandler();
        this.notification('success', 'Sucesso', 'Registro salvo com sucesso.');
      },
      (err) => {
        this.hideLoading();
        if (err.response.status === 403) {
          alert('403');
        } else {
          this.notification(
            'danger',
            'Erro',
            'Não foi possível salvar o registro. Tente novamente ou entre em contato com nosso suporte técnico'
          );
        }
      }
    );
  };

  toggleModal = () => {
    this.setState((prevState) => ({ modal: !prevState.modal }));
  };

  notification = (color, title, message) =>
    showNotification(notificationInstance, color, title, message);

  showLoading() {
    const { dispatch } = this.props;
    dispatch(changeLoadingTrue());
  }

  hideLoading() {
    const { dispatch } = this.props;
    dispatch(changeLoadingFalse());
  }

  render() {
    const { t } = this.props;
    const { data, formOn, selectedDto, modal } = this.state;
    const content = formOn ? (
      <EducationStageForm
        onSubmit={this.handleSubmit}
        backHandler={this.backClickHandler}
        notification={this.notification}
        dto={selectedDto}
      />
    ) : (
      <Container>
        <Row className="Table">
          <Col md={12} lg={12}>
            <Card>
              <CardBody className="material-table-card">
                <div className="material-table__wrap">
                  <MatTable
                    onRefreshClick={this.loadData}
                    onAddClick={this.addItemClickHandler}
                    onEditClick={this.editItemClickHandler}
                    onRemoveClick={this.removeItemClickHandler}
                    data={data}
                    columns={columns(t)}
                    pageSize={20}
                    deleteAction={this.toggleModal}
                    title={t('panels.ensino')}
                  />
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    );
    return (
      <Fragment>
        <Modal
          color="warning"
          title={t('notifications.attention')}
          btn="Warning"
          message={t('notifications.delete_modal')}
          toggle={this.toggleModal}
          modal={modal}
          onConfirm={this.deleteItem}
        />
        {content}
      </Fragment>
    );
  }
}

export default withTranslation('common')(
  connect((state) => ({
    loading: state.loading,
  }))(EducationStage)
);
